import { render, staticRenderFns } from "./sclInterpretation.vue?vue&type=template&id=a5835f96&scoped=true"
import script from "./sclInterpretation.vue?vue&type=script&lang=js"
export * from "./sclInterpretation.vue?vue&type=script&lang=js"
import style0 from "./sclInterpretation.vue?vue&type=style&index=0&id=a5835f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5835f96",
  null
  
)

export default component.exports